// extracted by mini-css-extract-plugin
var _1 = "PostInsights-module__animateUploadProgressBarWidth--i35vB";
var _2 = "PostInsights-module__animatedBackground--suVMF";
var _3 = "PostInsights-module__container--KilH2";
var _4 = "PostInsights-module__controlBarMenuButton--NBuCG";
var _5 = "PostInsights-module__insightsTooltip--TKzPn";
var _6 = "PostInsights-module__metricLabels--kLtya";
var _7 = "PostInsights-module__section--isU5C";
var _8 = "PostInsights-module__sectionChart--ReLW_";
var _9 = "PostInsights-module__sectionHeader--xU0S7";
var _a = "PostInsights-module__sectionHeaderTitle--aaZl8";
var _b = "PostInsights-module__uiUpdateNotice--g5sSt";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "controlBarMenuButton", _5 as "insightsTooltip", _6 as "metricLabels", _7 as "section", _8 as "sectionChart", _9 as "sectionHeader", _a as "sectionHeaderTitle", _b as "uiUpdateNotice" }
